import { Dialog, DialogContent,DialogTitle, Button, DialogActions } from "@material-ui/core";
import React from "react";
import {  Transition } from "../DialogTitle";



export const ModalTowButton = ({ setopenMondal, isOpen, reload, title, handledAccept, Messange }) => {

    const clearData = () => {
        setopenMondal(false)
        reload()
    }


    return (
        <>
            <div>
                <Dialog
                    onClose={(e) => { clearData() }}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%", height: 300 }}
                    fullWidth={true}
                    maxWidth="xs"
                >
                    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                     <DialogContent style={{ textAlign: "center" }}>
                        <p style={{ fontSize: 18 }}>{Messange}</p>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={handledAccept}>
                            Aceptar
                        </Button>

                        <Button variant="contained" color="primary" onClick={clearData}>
                            Cancelar
                        </Button>
                    </DialogActions>


                </Dialog>
            </div>
        </>
    );
}